import axios from "axios";
import { apiPath, apiPath1 } from "../../constants/config";
let token = localStorage.getItem("accessToken");
import moment from "moment";
let config = {
  headers: {
    Authorization: "Bearer " + token
  }
};
const state = {
  restoInfo : {

  },
  menuName : "",
  isLoadRestaurants: false,
  isLoadRestau: false,
  errorRestau: "",
  monresto_reservations: [],
  restaurants: [],
  restaurantsSearchResult: null,
  conversationsRestau: null,
  clientMessage: "",
  restau: {},
  tables: [],
  flagAsyncResMenu: false,
  reservations: [],
  all_reservations: [],
  countDataHasPos: 0,
  tables_status: [],
  open_checks: [],
  active_hours: [],
  dates_reservations: [],
  startGetTables: true,
  serving_periods: [],
  restorating : 0,
  restoratingcount : 0,
  suggesteditems : [],

};

const getters = {
  flagAsyncResMenu: state => state.flagAsyncResMenu,
  isLoadRestaurants: state => state.isLoadRestaurants,
  monresto_reservations: state => state.monresto_reservations,
  isLoadRestau: state => state.isLoadRestau,
  errorRestau: state => state.errorRestau,
  restaurants: state => state.restaurants,
  clientMessage1: state => state.clientMessage1,
  restau: state => state.restau,
  tables: state => state.tables,
  reservations: state => state.reservations,
  all_reservations: state => state.all_reservations,
  dates_reservations: state => state.dates_reservations,
  today_status: state => state.tables_status.filter((item) => { return (moment().format("YYYY-MM-DD") == moment(item.LastServiceTime).format("YYYY-MM-DD")) }),
  countDataHasPos: state => state.countDataHasPos,
  tables_status: state => state.tables_status,
  open_checks: state => state.open_checks,
  active_hours: state => state.active_hours,
  startGetTables: state => state.startGetTables,
  serving_periods: state => state.serving_periods,
  restorating: state => state.restorating,
  restoratingcount: state => state.restoratingcount,
  suggesteditems: state => state.suggesteditems,
  menuName: state => state.menuName,
};

const mutations = {
  setMenuNameSuccess(state,payload){
    state.menuName = payload.menuName;
  },
  syncFlagResMenu(state, payload) {
    state.flagAsyncResMenu = payload;
  },
  getRestaurantsSuccess(state, payload) {
    state.isLoadRestaurants = true;
    state.restaurants = payload.restaurants;
  },
  countDataHasPos(state, payload) {
    // state.isLoadRestaurants = true;
    state.countDataHasPos = payload.countDataHasPos;
  },
  getRestauSuccess(state, payload) {
    state.isLoadRestaurants = true;
    state.restau = payload.restau;
  },
  getReservationSuccess(state, payload) {
    state.all_reservations = payload;
  },
  getMonrestoReservationSuccess(state, payload) {
    state.monresto_reservations = payload;
  },
  getDatesReservationSuccess(state, payload) {
    state.dates_reservations = payload;
  },
  getTablesStatusSuccess(state, payload) {
    state.tables_status = payload;
  },
  getOpenChecksSuccess(state, payload) {
    state.open_checks = payload;
  },
  checkTableHoursSuccess(state, payload) {
    state.active_hours = payload;
  },
  getTablesSuccess(state, payload) {
    console.log()
    state.reservations = payload.reservations;
    state.isLoadRestaurants = true;
    state.tables = payload.tables;

    state.startGetTables = false;
  },
  setRestoRatingSuccess(state, payload) {
    state.restorating = payload;
  },
  setRestoRatingCountSuccess(state, payload) {
    state.restoratingcount = payload;
  },
  setTopItemsSuccess(state, payload) {
    state.suggesteditems = payload.topitemsWdetails;
  },
  addRestaurantSuccess(state, payload) {
    state.isLoadRestaurants = true;
    let restaurants = state.restaurants;
    restaurants.push(payload.data);
    state.restaurants = restaurants;
  },
  editRestaurantSuccess(state, payload) {
    state.isLoadRestaurants = true;
    let restaurants = state.restaurants;

    let newRestaurants = [];
    restaurants.map((restaurant, index) => {
      if (restaurant._id == payload.data._id) {
        newRestaurants.push({ ...payload.data });
      } else {
        newRestaurants.push({ ...restaurant });
      }
    });

    state.restaurants = [...newRestaurants];
  },
  deleteRestaurantSuccess(state, payload) {
    state.isLoadRestaurants = true;
    let restaurants = state.restaurants;

    let newRestaurants = [];
    restaurants.map((restaurant, index) => {
      if (restaurant._id != payload.data._id) {
        newRestaurants.push({ ...restaurant });
      }
    });
    state.restaurants = [...newRestaurants];
  },
  addROOMSuccess(state, payload) {
    state.isLoadRestaurants = true;

    state.clientMessage = "Merci pour votre inscription";
  },
  getRestaurantsError(state, error) {
    state.isLoadRestaurants = false;
    state.errorRestau = error;
  },
  addRestaurantError(state, error) {
    state.isLoadRestaurants = false;
    state.errorRestau = error;
  },
  startGettingTables(state, payload) {
    state.startGetTables = true;
  },
  getServingPeriodsSuccess(state, payload) {
    state.serving_periods = payload.serving_periods
  },
  getServingPeriodsError(state, payload) {

  }

};

const actions = {

  getMenuName({ commit }, payload) {
    console.log('HAAAA L P'+payload)
    commit("setMenuNameSuccess", {
      menuName: payload
    })
  },
  getServingPeriods({ commit }, payload) {
    // token = localStorage.getItem("accessToken")

    axios
      .get(`${apiPath}/serving/period?restaurant=${payload}`)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("getServingPeriodsSuccess", {
            serving_periods: res.data
          });
        } else {
          commit("getServingPeriodsError", "error:getServingPeriods");
        }
      });
  },

  getTables({ commit }, payload) {
    commit("startGettingTables", false);
    token = localStorage.getItem("accessToken");
    config = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    axios
      .get(
        `${apiPath}/tables/${payload.restaurant}/${payload.menu.rvc}?design=${payload.design ? 1 : 0}&containerWidth=${payload.containerWidth}&containerHeight=${payload.containerHeight}`,
        config
      )
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("getTablesSuccess", {
            tables: res.data,
            reservations: res.reservations
          });
        } else {
          commit("getRestaurantsError", "error:getRestaurants");
        }
      });
  },

  editTables({ commit }, payload) {
    token = localStorage.getItem("accessToken");
    config = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    return axios
      .post(`${apiPath}/edit/tables`, payload, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          // commit("getTablesSuccess", {
          //   tables: res.data
          // });
        } else {
          commit("getRestaurantsError", "error:getRestaurants");
        }
        return res;
      });
  },
  getAllReservations({ commit }, payload) {
    token = localStorage.getItem("accessToken");
    config = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    return axios
      .post(`${apiPath}/get/date/reservations`, payload, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("getReservationSuccess", res.reservations);
        } else {
          commit("getRestaurantsError", "error:getRestaurants");
        }
        return res;
      });
  },

  getDatesReservations({ commit }, payload) {
    token = localStorage.getItem("accessToken");
    config = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    return axios
      .post(`${apiPath}/get/dates/reservations`, payload, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("getDatesReservationSuccess", res.reservations);
        } else {
          commit("getRestaurantsError", "error:getRestaurants");
        }
        return res;
      });
  },
  getTablesStatus({ commit }, payload) {
    token = localStorage.getItem("accessToken");
    config = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    return axios
      .post(`${apiPath}/get/tables/status`, payload, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("getTablesStatusSuccess", res.status);
        } else {
          commit("getRestaurantsError", "error:getRestaurants");
        }
        return res;
      });
  },
  getOpenChecks({ commit }, payload) {
    token = localStorage.getItem("accessToken");
    config = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    return axios
      .post(`${apiPath}/get/open/checks`, payload, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("getOpenChecksSuccess", res.checks);
        } else {
          commit("getRestaurantsError", "error:getRestaurants");
        }
        return res;
      });
  },
  commitCheckTableHoursResult({ commit }, payload) {
    commit("checkTableHoursSuccess", payload.hours);
  },
  commitGetReservationsByDateResult({ commit }, payload) {

    commit("getReservationSuccess", payload.reservations);
    commit("getMonrestoReservationSuccess", payload.monresto_reservations);
    return payload;

  },
  checkTableHours({ commit }, payload) {
    token = localStorage.getItem("accessToken");
    config = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    // {restaurant,date:res_date,rvc:1}
    return axios
      .post(`${apiPath}/get/reservations`, payload, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("checkTableHoursSuccess", res.hours);
        } else {
          commit("getRestaurantsError", "error:getRestaurants");
        }
        return res;
      });
  },
  removeDecoration({ commit }, payload) {
    token = localStorage.getItem("accessToken");
    config = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    return axios
      .post(`${apiPath}/remove/decoration`, payload, config)
      .then(r => r.data)
      .then(res => {
        return res;
      });
  },

  getRestau({ commit }, payload) {
    token = localStorage.getItem("accessToken");
    config = {
      headers: {
        Authorization: "Bearer " + token
      }
    };

    return axios
      .get(`${apiPath}/retaurants/${payload}`, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("getRestauSuccess", {
            restau: res.data
          });
          return res;
        } else {
          commit("getRestaurantsError", "error:getRestaurants");
          return res;
        }
      });
  },
  getRestaurants({ commit }) {
    token = localStorage.getItem("accessToken");
    config = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    return axios
      .get(`${apiPath}/retaurants`, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("getRestaurantsSuccess", {
            restaurants: res.data
          });
          commit("countDataHasPos", {
            countDataHasPos: res.countDataHasPos
          });
        } else {
          commit("getRestaurantsError", "error:getRestaurants");
        }
      });
  },

  async restaurantRating({ commit }, payload) {

    return axios
      .get(
        `${apiPath}/restaurant-rating/${payload}`
      ).then(r => r.data).then(res => {
        if (res.ok) {
          commit("setRestoRatingSuccess", res.RestaurantRating);

        }
        // return res;
      });
  },
  async restaurantRatingCount({ commit }, payload) {

    return axios
      .get(
        `${apiPath}/restaurant-rating-count/${payload}`
      ).then(r => r.data).then(res => {
        if (res.ok) {
          commit("setRestoRatingCountSuccess", res.ServiceRatings);

        }
        // return res;
      });
  },

  async getTopItems({ commit }, payload) {

    return axios
      .get(
        `${apiPath}/top-five-suggestion/${payload.restaurant}/${payload.menu}`
      ).then(r => r.data).then(res => {
        if (res.ok) {
          commit("setTopItemsSuccess",
          {
            topitems: res.topsalesitems,
            topitemsWdetails : res.items_menu_sales
          });

        }
        // return res;
      });
  },

  addRestaurant({ commit }, payload) {
    return axios
      .post(`${apiPath}/retaurants`, payload, config)
      .then(r => r)
      .catch(error => error);
  },
  saveRestaurantConfig({ commit }, payload) {
    return axios
      .post(`${apiPath}/config/save/retaurants`, payload, config)
      .then(r => r)
      .catch(error => error);
  },
  addRestaurant_simple({ commit }, payload) {
    return axios
      .post(`${apiPath}/retaurants_simple`, payload, config)
      .then(r => r)
      .catch(error => error);
  },
  editRestaurant({ commit }, payload) {
    return axios
      .post(`${apiPath}/retaurants/${payload.id}`, payload.data, config)
      .then(r => r);
    // .then(res => {
    //   if (res.ok) {
    //     commit("editRestaurantSuccess", res);
    //   } else {
    //     commit("addRestaurantError", "error:addRestaurant");
    //   }
    //   return res;
    // });
  },
  editRestaurantInfos({ commit }, payload) {
    return axios
      .post(`${apiPath}/infos/retaurants/${payload.id}`, payload.data, config)
      .then(r => r);
    // .then(res => {
    //   if (res.ok) {
    //     commit("editRestaurantSuccess", res);
    //   } else {
    //     commit("addRestaurantError", "error:addRestaurant");
    //   }
    //   return res;
    // });
  },
  editRestaurant_configuration({ commit }, payload) {
    return axios
      .put(
        `${apiPath}/retaurants_configuration/${payload._id}`,
        payload,
        config
      )
      .then(r => r);
  },
  editRestaurantPayment({ commit }, payload) {
    return axios
      .put(
        `${apiPath}/retaurants_configuration_payment/${payload._id}`,
        payload,
        config
      )
      .then(r => r);
  },
  async SyncRestau({ commit }, payload, config) {
    if (!payload || !payload.rvc) {
      return;
    }

    axios
      .post(`${apiPath1}/sync/${payload._id}/get/menu/slu`, payload)
      .then(r => r.data)
      .then(res => {
        return res;
      });

    axios
      .post(`${apiPath1}/sync/${payload._id}/get/menu/tables`, payload)
      .then(r => r.data)
      .then(res => { });
    axios
      .post(`${apiPath1}/sync/${payload._id}/get/menu/price`, payload)
      .then(r => r.data)
      .then(res => { });
    axios
      .post(`${apiPath1}/sync/${payload._id}/get/menu/class`, payload)
      .then(r => r.data)
      .then(res => { });
    axios
      .post(`${apiPath1}/sync/${payload._id}/get/family/group`, payload)
      .then(r => r.data)
      .then(res => { });

    axios
      .post(`${apiPath1}/sync/${payload._id}/get/family/major`, payload)
      .then(r => r.data)
      .then(res => { });

    axios
      .post(`${apiPath1}/sync/${payload._id}/get/employees`, payload)
      .then(r => r.data)
      .then(res => { });

    axios
      .post(`${apiPath1}/sync/${payload._id}/get/menu/menu`, payload)
      .then(r => r.data)
      .then(res => { });
    axios
      .post(`${apiPath1}/sync/${payload._id}/get/main/menu`, payload)
      .then(r => r.data)
      .then(res => { });
    axios
      .post(`${apiPath1}/sync/${payload._id}/get/sub/menu`, payload)
      .then(r => r.data)
      .then(res => { });
    axios
      .post(`${apiPath1}/sync/${payload._id}/get/tender/media`, payload)
      .then(r => r.data)
      .then(res => { });
    axios
      .post(`${apiPath1}/sync/${payload._id}/get/order/type`, payload)
      .then(r => r.data)
      .then(res => { });
    await axios
      .post(`${apiPath1}/sync/${payload._id}/get/menu/master`, payload)
      .then(r => r.data)
      .then(res => {
        return res;
      });
    return await axios
      .post(`${apiPath1}/sync/${payload._id}/get/menu/definition`, payload)
      .then(r => r.data)
      .then(res => { });
    // .catch(res => res);
  },
  async SyncRestauRes({ commit }, payload, conifg) {
    if (!payload || !payload.rvc) {
      return;
    }
    // api/v1/web/rest/pos/:index
    for (let index = 1; index < 20; index++) {
      await axios
        .post(`${apiPath}/rest/pos/${index}`, payload)
        .then(r => r.data)
        .then(res => res)
        .catch(res => {
          commit("syncFlagResMenu", true);
          index = 100;
          console.log(res);
        });
    }
  },

  deleteRestaurant({ commit }, payload) {
    return axios
      .delete(`${apiPath}/retaurants/${payload._id}`, config)
      .then(r => r.data)
      .then(res => {
        // if (res.ok) {
        //   commit("deleteRestaurantSuccess", payload);
        // } else {
        //   commit("addRestaurantError", "error:addRestaurant");
        // }
        return payload;
      });
  },
  createClient({ commit }, payload) {
    return axios
      .post(`${apiPath}/create/client`, payload)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("addSuccess", res);
        } else {
        }
        return res;
      });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
